/**
 * The backend's own sentence for a refused request, and the code beside it.
 *
 * The wording is deliberate on that side and worth carrying through unchanged: "your
 * role has no AI usage limits configured" is a five-minute admin fix, "you do not have
 * access" is a permission grant, and "the AI workspace is currently turned off" is an
 * incident. Flattening the three into one generic failure message is the entire support
 * burden of the first fortnight.
 *
 * The code is kept alongside because it is what makes a screenshot actionable — someone
 * forwarding "E42-002" gets an answer, someone forwarding "something went wrong" gets a
 * conversation.
 *
 * @param {Object} error - an axios error
 * @param {String} fallback - what to say when the response carries no message of its own
 * @returns {Object} { message, code }
 */
export function describeApiError(error, fallback) {
  const data = error && error.response ? error.response.data : null;

  return {
    message:
      (data && (data.message || data.detail)) ||
      fallback ||
      "Something went wrong. Try again.",
    code: data && data.code ? data.code : null,
  };
}

export default describeApiError;
